import { EncryptStorage } from "encrypt-storage";

const encryptStorage1 = new EncryptStorage("secret-key", {
  prefix: "@instance1",
});

const encryptStorage2 = new EncryptStorage("secret-key1", {
  prefix: "@instance2",
});

const encryptStorage3 = new EncryptStorage("secret-key3", {
  prefix: "@instance3",
});

const encryptStorage4 = new EncryptStorage("secret-key4", {
  prefix: "@instance4",
});

const encryptStorage5 = new EncryptStorage("secret-key5", {
  prefix: "@instance5",
});
const encryptStorage6 = new EncryptStorage("secret-key6", {
  prefix: "@instance6",
});
const encryptStorage7 = new EncryptStorage("secret-key7", {
  prefix: "@instance7",
});
const getUser = () => {
  return encryptStorage1.getItem("user-azalea"); //jwt
};

const getUserObject = () => {
  const saved = encryptStorage2.getItem("user-data");
  return saved && typeof saved === "object" ? saved : null; //email && pass
};

const getCompID = () => {
  const savedArray = encryptStorage3.getItem("user-azalea");
  return savedArray ? savedArray : null; //compID
};

const getBPID = () => {
  const savedArray = encryptStorage4.getItem("user-azalea");
  return savedArray ? savedArray : null; //BusinessProfileID
};

const getupidata = () => {
  return encryptStorage5.getItem("user-upi"); //upi
};
const getCompName = () => {
  return encryptStorage6.getItem("comp-azalea"); //CompName
};
const getQrJodID = () => {
  return encryptStorage7.getItem("QR-job"); //QR Job ID
};
export const userService = {
  getUser,
  getCompID,
  getBPID,
  getUserObject,
  getupidata,
  getCompName,
  getQrJodID,
};
